import { getThemeColors } from "../configs/theme.colors"

export const PatternWarningLevels = {
    NEUTRAL: 0,
    HIGH: 1,
    MODERATE: 2,
    POSITIVE: 3,
}

export const getPatternWarningLevelName = level => {
    switch (level) {
        case PatternWarningLevels.NEUTRAL:
            return 'Neutral'
        case PatternWarningLevels.HIGH:
            return 'High'
        case PatternWarningLevels.MODERATE:
            return 'Moderate'
        case PatternWarningLevels.POSITIVE:
            return 'Positive'
        default:
            return 'Unknown pattern warning level'
    }
}

export const getPatternWarningLevelDescription = level => {
    switch (level) {
        case PatternWarningLevels.NEUTRAL:
            return 'Informational feedback - neutral observation about your code'
        case PatternWarningLevels.HIGH:
            return 'High priority issue in your code that should be addressed'
        case PatternWarningLevels.MODERATE:
            return 'Moderate concern or area for improvement in your code'
        case PatternWarningLevels.POSITIVE:
            return 'Good practice or correct implementation observed in your code'
        default:
            return 'Unknown pattern warning level'
    }
}

/**
 * Get pattern warning level color based on current theme
 * Reads theme from document attribute to support dark mode
 */
export const getPatternWarningLevelColor = level => {
    const themeMode = document.documentElement.getAttribute('data-theme') || 'light'
    const colors = getThemeColors(themeMode)
    
    switch (level) {
        case PatternWarningLevels.NEUTRAL:
            return colors.info
        case PatternWarningLevels.HIGH:
            return colors.error
        case PatternWarningLevels.MODERATE:
            return colors.warning
        case PatternWarningLevels.POSITIVE:
            return colors.success
        default:
            return colors.text
    }
}
